import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5055b243"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16" }
const _hoisted_2 = { class: "px-6 py-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Solicitação de comissão", -1))
const _hoisted_4 = {
  key: 0,
  class: "grid grid-cols-12 gap-4"
}
const _hoisted_5 = { class: "grid grid-cols-12 col-span-12 gap-4" }
const _hoisted_6 = { class: "col-span-12 md:col-span-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Protocolo ", -1))
const _hoisted_8 = { class: "data" }
const _hoisted_9 = {
  key: 0,
  class: "col-span-12 md:col-span-6"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " CNPJ da Software House ", -1))
const _hoisted_11 = { class: "data" }
const _hoisted_12 = { class: "col-span-12 md:col-span-6" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Situação ", -1))
const _hoisted_14 = { class: "data" }
const _hoisted_15 = { class: "col-span-12 md:col-span-6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Período ", -1))
const _hoisted_17 = { class: "data" }
const _hoisted_18 = { class: "col-span-12 md:col-span-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Valor ", -1))
const _hoisted_20 = { class: "data" }
const _hoisted_21 = {
  key: 1,
  class: "col-span-12 md:col-span-6"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Mensagem ", -1))
const _hoisted_23 = { class: "data" }
const _hoisted_24 = { class: "col-span-12 md:col-span-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Data solicitação ", -1))
const _hoisted_26 = { class: "data" }
const _hoisted_27 = { class: "col-span-12 md:col-span-6" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Data Atualização ", -1))
const _hoisted_29 = { class: "data" }
const _hoisted_30 = { class: "col-span-12 md:col-span-6" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Arquivos enviados ", -1))
const _hoisted_32 = { class: "data" }
const _hoisted_33 = {
  key: 2,
  class: "col-span-12 md:col-span-6"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " Comprovante de pagamento ", -1))
const _hoisted_35 = { class: "data" }
const _hoisted_36 = { class: "mt-3 col-span-12 flex w-full items-center justify-end gap-4 -lg:flex-col" }
const _hoisted_37 = {
  key: 1,
  class: "shadow overflow-hidden flex border-b border-gray-200 bg-gray-50 sm:rounded-lg w-full h-48"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("embed", {
  width: "50",
  height: "50",
  src: "/colorful-loading.gif",
  class: "m-auto"
}, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["hidden"]
const _hoisted_41 = { class: "w-1/2 bg-white m-auto rounded-lg p-3 z-50" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-black text-2xl" }, " Solicitação de repasse de comissão ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "my-3 text-base" }, "Você deseja aprovar ou rejeitar a solicitação?", -1))
const _hoisted_44 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_45 = { class: "md:flex gap-5" }
const _hoisted_46 = { class: "grid" }
const _hoisted_47 = { class: "file-upload-wrapper custom-button rounded-lg w-48 h-12 justify-center items-center justify-self-center" }
const _hoisted_48 = {
  for: "inputFile",
  class: "file-upload-label justify-center items-center"
}
const _hoisted_49 = { class: "self-center h-full flex items-center justify-center text-white mx-2" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mb-px font-semibold leading-none mx-2" }, "Adicionar arquivo", -1))
const _hoisted_51 = { class: "my-1 p-2 text-sm text-red-500 mt-1" }
const _hoisted_52 = {
  key: 0,
  class: "text-sm",
  style: {"display":"ruby"}
}
const _hoisted_53 = { class: "file-uploaded-wrapper custom-button rounded-lg w-48 h-12 justify-center items-center justify-self-center mb-2" }
const _hoisted_54 = { class: "file-uploaded-label items-center justify-between" }
const _hoisted_55 = { class: "self-center h-full flex items-center justify-center text-white mx-2" }
const _hoisted_56 = { class: "truncate mb-px leading-none" }
const _hoisted_57 = { class: "self-center h-full flex items-center justify-center text-white mx-2" }
const _hoisted_58 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_59 = { class: "flex items-center mt-4 h-full w-full justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.commissionRequestData.protocol), 1)
              ]),
              (_ctx.isApprovalUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatCnpj(_ctx.softwareHouseCnpj)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.commissionRequestStatus[_ctx.commissionRequestData.status]), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.commissionRequestData.interval), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, _toDisplayString(Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(_ctx.commissionRequestData.value)), 1)
              ]),
              (_ctx.commissionRequestData.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.commissionRequestData.message), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.commissionRequestData.createdAt ? _ctx.formatDate(_ctx.parseISODate(_ctx.commissionRequestData.createdAt), 'dd/MM/yyyy') : ''), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.commissionRequestData.updatedAt ? _ctx.formatDate(_ctx.parseISODate(_ctx.commissionRequestData.updatedAt), 'dd/MM/yyyy') : ''), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_Button, {
                    disabled: _ctx.downloadInProgress,
                    label: "Baixar",
                    icon: _ctx.buttonIcons.download.icon,
                    width: "w-48 -lg:w-full",
                    type: "button",
                    onClick: _ctx.downloadCommissionRequestAttachmentFiles
                  }, null, 8, ["disabled", "icon", "onClick"])
                ])
              ]),
              (_ctx.commissionRequestData.originalStatus === 'approved')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_Button, {
                        disabled: _ctx.downloadInProgress,
                        label: "Baixar",
                        icon: _ctx.buttonIcons.download.icon,
                        width: "w-48 -lg:w-full",
                        type: "button",
                        onClick: _ctx.downloadCommissionRequestPaymentProofFile
                      }, null, 8, ["disabled", "icon", "onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_Button, {
                label: "Voltar",
                icon: _ctx.buttonIcons.cancel.icon,
                width: "w-48 -lg:w-full",
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
              () => {
                _ctx.$router.go(-1);
              }
            )
              }, null, 8, ["icon"]),
              (_ctx.isApprovalUser && _ctx.commissionRequestData.originalStatus === 'pending')
                ? (_openBlock(), _createBlock(_component_PrimaryButton, {
                    key: 0,
                    label: "Editar",
                    icon: _ctx.buttonIcons.save.icon,
                    iconCustomClass: "text-white",
                    width: "w-48 -lg:w-full",
                    type: "submit",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editCommissionRequest()))
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: "toast-block",
      hidden: _ctx.hidden,
      onHide: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.hide()), ["self"]))
    }, [
      _createVNode(_component_Toast, {
        label: _ctx.message,
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.hide()), ["self"])),
        success: _ctx.toastSuccess
      }, null, 8, ["label", "success"])
    ], 40, _hoisted_40),
    _createElementVNode("div", {
      id: "overlay",
      class: _normalizeClass(["fade-in", _ctx.approveOrRejectCommissionRequestModal ? 'block' : 'hidden fade-out'])
    }, [
      _createElementVNode("div", {
        class: "h-screen flex overflow-y-scroll p-8",
        onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.approveOrRejectCommissionRequestModal = false), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _hoisted_43,
          (_openBlock(), _createBlock(_component_Select, {
            label: "Nova Situação",
            options: () => _ctx.commissionRequestStatusAccepted,
            key: _ctx.selectedCommissionRequestStatusToUpdate.key,
            selected: _ctx.selectedCommissionRequestStatusToUpdate.value,
            display: "value",
            class: "mt-3 w-1/2 -lg:w-full",
            event: "update:select",
            "onUpdate:select": _ctx.handleCommissionRequestStatus
          }, null, 8, ["options", "selected", "onUpdate:select"])),
          (_ctx.selectedCommissionRequestStatusToUpdate.key === 'approved')
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createVNode(_component_Input, {
                  modelValue: _ctx.commissionRequestForm.receiptDate,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.commissionRequestForm.receiptDate) = $event)),
                  type: "date",
                  label: "Data de recebimento"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("input", {
                        id: "inputFile",
                        ref: "imageUploader",
                        placeholder: "Imagem de perfil",
                        title: "Imagem de perfil",
                        type: "file",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetFile && _ctx.resetFile(...args))),
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fileChangeHandler && _ctx.fileChangeHandler(...args))),
                        name: "attachment",
                        class: "file-upload-input"
                      }, null, 544),
                      _createElementVNode("label", _hoisted_48, [
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(_component_FontAwesomeIcon, {
                            icon: _ctx.buttonIcons.upload.icon
                          }, null, 8, ["icon"])
                        ]),
                        _hoisted_50
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.errorMessage), 1)
                  ]),
                  (_ctx.commissionRequestForm.file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("label", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_FontAwesomeIcon, {
                                  icon: _ctx.buttonIcons.file.icon
                                }, null, 8, ["icon"])
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_56, _toDisplayString(_ctx.commissionRequestForm.file.name), 1),
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)))
                              }, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_FontAwesomeIcon, {
                                    icon: _ctx.buttonIcons.trash.icon
                                  }, null, 8, ["icon"])
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedCommissionRequestStatusToUpdate.key === 'rejected')
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createVNode(_component_TextArea, {
                  modelValue: _ctx.commissionRequestForm.message,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.commissionRequestForm.message) = $event)),
                  label: "Motivo da recusa"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_PrimaryButton, {
              label: "Salvar",
              onClick: _ctx.updateCommissionRequest,
              disabled: _ctx.loading,
              iconCustomClass: "text-white",
              width: "w-48 -lg:w-full",
              type: "submit"
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ])
    ], 2)
  ]))
}